/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Error_TitleInputs */

const en_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const fr_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur`)
};

const de_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler`)
};

const it_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore`)
};

const ru_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка`)
};

const es_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const zh_cn2_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误`)
};

const ja_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const hi_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती`)
};

const pt_pt2_ateliere_connect_error_title = /** @type {(inputs: Ateliere_Connect_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Ateliere_Connect_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_error_title = /** @type {((inputs?: Ateliere_Connect_Error_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Error_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_error_title(inputs)
	if (locale === "de") return de_ateliere_connect_error_title(inputs)
	if (locale === "it") return it_ateliere_connect_error_title(inputs)
	if (locale === "ru") return ru_ateliere_connect_error_title(inputs)
	if (locale === "es") return es_ateliere_connect_error_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_error_title(inputs)
	if (locale === "ja") return ja_ateliere_connect_error_title(inputs)
	if (locale === "hi") return hi_ateliere_connect_error_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_error_title(inputs)
	return en_ateliere_connect_error_title(inputs)
});